import * as ActionTypes from "constants/ActionTypes";
import get from "lodash/get";

import { call, put, select, takeLatest } from "redux-saga/effects";
import { delay } from "redux-saga";

function* resetAdState() {
  const interstitialAdTimeoutSeconds = yield select((state) =>
    get(state, "story.ads.interstitialAdTimeoutSeconds", null),
  );
  if (interstitialAdTimeoutSeconds) {
    yield call(delay, interstitialAdTimeoutSeconds * 1000);
    yield put({
      type: ActionTypes.SET_IS_READY_FOR_AD_RESET,
    });
  }
}

export default function* adResetSaga() {
  yield takeLatest([ActionTypes.AD_COMPLETED], resetAdState);
}
